// Alpine.js
import Alpine from 'alpinejs'
import alpineApp from './alpine/app.js'
window.Alpine = Alpine
Alpine.data('app', alpineApp)
Alpine.start()

// Barba.js
require('./barba')

// Initialise site-wide Vue components
import { search } from './vue'
search()

// if window scroll is more than 10px add class to header element
let header = document.getElementsByTagName('header')[0]
window.onscroll = function() {
	if (window.scrollY > 1) {
		header.classList.add('scrolled')
	} else {
		header.classList.remove('scrolled')
	}
}
